import React, { useContext } from 'react'
import LanguagePicker, { ILanguageOption } from 'Components/reusable/InputFields/LanguagePicker'
import { ILanguageSkill } from 'types/cvsInterfaces'
import { LanguageCode } from 'types/ids'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Person picker.
 */
export const DataEditContextLanguageField = <T extends AnyObject>({
  field,
  languageOptions,
  submitOnEnter,
  icon,
  disableClearable,
  insetLabel,
  ...rest
}: {
  field: EditableFieldsOfType<T, LanguageCode | null>
  languageOptions: ILanguageOption[]
  submitOnEnter?: boolean
  icon?: React.ReactElement
  disableClearable?: boolean
  insetLabel?: boolean
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t, handleSubmit } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: ILanguageSkill | null) => {
    setFields({ [field]: newValue })
  }

  const dataValue = flatData[field] as unknown as string

  return (
    <LanguagePicker
      onChange={handleChange}
      disabled={disabled[field] ?? false}
      value={dataValue}
      label={t(`${localeBase}.${field}`)}
      onKeyDown={e => submitOnEnter && handleSubmit(e)}
      languageOptions={languageOptions}
      icon={icon}
      disableClearable={disableClearable}
      insetLabel={insetLabel}
      {...rest}
    />
  )
}

/**
 * Type picker.
 */
